<template>
  <div class="contact-port-page">
    <Banner :bannerUrl="bannerUrl" :title="$t('contactPortPage.bannerTitle')" />
    <div class="container">
      <div class="port-list fs">
        <div class="port-item" v-for="(item, index) in $tm('contactPortPage.port')" :key="index">
          <div class="city">{{ item.city }}</div>
          <div class="content">
            <p>{{ $t('email') }}：info@hstocean.com</p>
            <p>{{ item.address }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import Banner from '@/components/banner';
const bannerUrl = require('@assets/images/banner/banner-contact-port.png');
</script>

<style lang="less" scoped>
.contact-port-page {
  margin-bottom: 223px;
  /deep/ .com-banner .banner_title {
    left: 50%;
    transform: translate(-50%, 40px);
    font-size: 32px;
  }
  .container {
    margin-top: 115px;

    .port-list {
      align-items: flex-start;
      flex-wrap: wrap;
      gap: 26px;
      .port-item {
        width: 376px;
        background: #FBFBFB;
        .city {
          height: 50px;
          font-size: 18px;
          font-weight: 600;
          padding-left: 28px;
          line-height: 50px;
          color: #fff;
          background-color: #3071FF;
        }
        .content {
          padding: 30px 24px;
          color: #7D7D7D;
          font-size: 16px;
          line-height: 24px;
          p {
            margin-bottom: 14px;
            &:last-child {
              margin-bottom: 0;
            }
          }
        }
      } 
    }
  }
}
</style>